import React from 'react';
import { PropTypes } from 'prop-types';
import { constants as stopConstants } from 'utils/dateAndTimes';
import { useTranslation } from 'react-i18next';

import Tooltip from 'components/Tooltip';
import {
  HandlingLoadIcon,
  HandlingUnloadIcon,
  HandlingLoadNotNeededIcon,
  HandlingUnloadNotNeededIcon,
  GirdedQuestionIcon,
  GirdedInfoIcon,
} from 'refactored/ui/icons';

import useIsSpainCountry from 'hooks/useIsSpainCountry';
import HandlingToolTipContent from './HandlingToolTipContent';

const Extra = ({
  className,
  stopType,
  hasError,
  stopId,
  handleChange,
  checked,
  isSelected,
  isHandlingAllowed,
}) => {
  const { t } = useTranslation('HandlingExtra');
  const isPickup = stopType === stopConstants.STOP_TYPES.pickup;
  const disabledClassName = !isHandlingAllowed ? 'disabled' : '';
  const isSpainCountry = useIsSpainCountry();

  return (
    <div className={className} data-testid="extra">
      <div className="handling-text">
        <span>
          {isPickup ? t('label_extra_pickup') : t('label_extra_dropoff')}
        </span>
        <Tooltip
          position="right"
          className="tooltip"
          component={<HandlingToolTipContent stopType={stopType} />}
          segmentTitle="form extras"
          segmentData={{ label: t(`label_${stopType}`) }}
        >
          <GirdedQuestionIcon />
        </Tooltip>
      </div>
      <div className="handling-container">
        <div className="handling-btn-container">
          <input
            disabled={!isHandlingAllowed}
            id={`${stopId}-handling-btn`}
            className={`handling-radio-btn ${disabledClassName}`}
            type="radio"
            name={stopId}
            label={t(`label_${stopType}`)}
            checked={isSelected ? checked : false}
            onChange={() => handleChange(true)}
          />
          <label
            htmlFor={`${stopId}-handling-btn`}
            className={`${disabledClassName} ${hasError}`}
          >
            <div className="input-representation"></div>
            {isPickup ? <HandlingLoadIcon /> : <HandlingUnloadIcon />}
            <span>{t('label_button_necessary')}</span>
          </label>
        </div>
        <div className="handling-btn-container">
          <input
            id={`${stopId}-nohandling-btn`}
            className="handling-radio-btn"
            type="radio"
            name={stopId}
            checked={isSelected ? !checked : false}
            onChange={() => handleChange(false)}
          />
          <label
            htmlFor={`${stopId}-nohandling-btn`}
            className={`no-handling-needed ${hasError}`}
          >
            <div className="input-representation"></div>
            {isPickup ? (
              <HandlingLoadNotNeededIcon />
            ) : (
              <HandlingUnloadNotNeededIcon />
            )}
            <span>{t('label_button_unnecessary')}</span>
          </label>
        </div>
        {/* ERROR */}
        {!!hasError && (
          <div className="button-msg-error">
            <GirdedInfoIcon className="error-info-icon" />
            <span> {t('select_option')} </span>
          </div>
        )}
        {/* INFO */}
        {isSelected && !checked && isHandlingAllowed && isSpainCountry && (
          <p>
            {isPickup
              ? t('no_handling_warning_pickup')
              : t('no_handling_warning_dropoff')}
          </p>
        )}
        {/* TLW */}
        {!isHandlingAllowed && (
          <div>
            <GirdedInfoIcon className={'disabled-info-icon'} />
          </div>
        )}
      </div>
    </div>
  );
};

Extra.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  tooltip: PropTypes.string,
};

Extra.defaultProps = {
  checked: false,
};

export default Extra;
